import styled from 'styled-components';

export const UserPanel = styled.div`
  height: 100%;
  width: 100%;
  background: white;
  cursor: auto;
  position: relative;
`;
